export default __webpack_public_path__ + "static/media/18.f7edf95d.jpg";